<div class="container">
  <div class="dashboard-section">
    <div class="dashboard-section-title">
      <h2 class="heading-level-2 blue-color" tabindex="0">Modify Economy</h2>
    </div>
    <div class="comman_mid_wraper">
      <div class="admin_wraper">
        <div class="comman_box">
          <div *ngFor="let economy of economy_sequences ; let economy_index = index" class="economy_class">
            <div class="economy_action_row">
              <label class="no_pad bold font-16 pull-left mb-0">Economy {{economy.name}} : </label>
              <a class="pull-left ml-10" *ngIf="economy.id" href="javascript:void(0)" (click)="viewEconomyPDF(economy)">
                <img class="delete-btn" src="/assets/images/document_pdf.svg" alt="View Economy {{economy.name}}" />
              </a>
              <span class="mx-1"></span>
              <a tabindex="0" (click)="save_economy(economy_index)">
                <img class="delete-btn" width="17px" src="/assets/images/save.svg" alt="Save Economy {{economy.name}}" title="Save" />
              </a>
              <span class="mx-1"></span>
              <a *ngIf="is_default_economy(economy)" tabindex="0" (click)="delete(economy_index)">
                <img class="delete-btn" width="17px" src="/assets/images/delete_icon.svg" alt="Delete Economy {{economy.name}}"
                  title="{{economy.id ? 'Delete' : 'Remove'}}" />
              </a>
            </div>
            <div><input *ngIf="economy.created_by === 'user'" type="text" class="add_economy_note" name="note"
                [(ngModel)]="economy.note" placeholder="Description"></div>
            <div class="full-width clear">
              <div *ngFor="let econ_value of economy.eseq_values_attributes; let eseq_val_index = index"
                class="economy_value">
                <input type="text" [hidden]="check_dec_index(eseq_val_index)"
                  [disabled]="economy.created_by === 'system'" [(ngModel)]="econ_value.econ_value" maxlength='2'
                  class="econ_value" title="economy_value" aria-label="Economy Value" 
                  [ngClass]="eseq_values_error[economy_index][eseq_val_index].includes('econ_value')? 'form_validation_error': ''" />
              </div>
            </div>
            <!-- <button (click)="save_economy(economy_index)" class="btn btn-primary comman_btn "> Save </button>
                <button (click)="delete_economy(economy_index)" class="btn btn-primary comman_btn ">Delete</button> -->

          </div>
          <a href="javascript:void(0)" *ngIf="check_economy_length() && econ_added.length==0" class="custom_icon" title="Add New Economy"><i
              class="fa fa-plus-square" aria-hidden="true" (click)="addNewEconomy()"></i></a>
          <div class="row ">
            <div class="col-lg-12">
              <a href="javascript:void(0)" (click)="redirectToSessionControl()" class="go-back-button pull-right"><img class="go-back-icon" src="assets/images/active_down_arrow.svg" alt="Back"/> Go
                Back</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Delete popup modal -->
<div id="customPopup" class="modal">
  <div class="modal-content modal-content-30">
    <div class="modal-main-content">
      <button class="close delete-close"><img src="assets/images/close_circle.svg" id="closeButton" alt="Close"></button>
      <h2 class="modal-heading center">Delete Economy</h2>
      <p class="modal-heading center">Are you sure, you want to delete?</p>
      <div class="button-container button-container-center">
        <button class="modal-button delete-close" id="cancelButton">Cancel</button>
        <button class="modal-button yes-button" id="deleteButton">Yes</button>
      </div>
    </div>
  </div>
</div>